import {LoaderFunctionArgs} from 'react-router-dom';
import {getRootStore} from '../../app.bootstrap';
import {getAppTracer} from '../../../app.tracer';
import {resolveUserAndAccount} from '../helper/auth-resolve.helper';
import {IHistoryStore, HistoryStore} from './history.stores';

const trace = getAppTracer('history.loader');

export async function historyRouteLoader(args: LoaderFunctionArgs): Promise<IHistoryStore | void> {
    trace.info('Starting');
    const rootStore = getRootStore();

    await rootStore.initRootServicesCompleted;

    const url = new URL(args.request.url);
    const redirectParams = Object.fromEntries(url.searchParams.entries());
    window.history.replaceState(null, '', url.pathname + url.search);

    const {currentUser, accountData} = await resolveUserAndAccount({redirectParams});

    const store = new HistoryStore(currentUser, accountData);

    trace.info('Completed successfully');
    return store;
}
